import type { ReactNode } from 'react';
import { PageLoader } from '@customerio/pluma-components/react';
import { SafeNavigate } from '@/services/router/safe-navigate';

const LOADING_LABEL = 'Loading…';

type JourneysHandoffViewProps = {
  /** The page's rollout flag, already read by the caller. */
  isMigrated: boolean;
  /** The migrated URL this one forwards to; `null` while the workspace resolves. */
  migratedHref: string | null;
  /** The embedded host, rendered while the flag is off. */
  children: ReactNode;
};

/**
 * The shell of a legacy `journeys` URL whose page has moved: flag off renders the embedded host
 * that still serves it, and flag on claims the URL only to forward it, so existing links and the
 * embedded app's own nav keep working without being re-pointed.
 *
 * The exact inverse of {@link MigrationRouteView}, and the two can't loop, because each fires in
 * the opposite flag state. The handoff replaces history, mirroring an Ember-route-hook redirect.
 */
export function JourneysHandoffView({ isMigrated, migratedHref, children }: JourneysHandoffViewProps) {
  if (!isMigrated) {
    return children;
  }

  if (migratedHref == null) {
    return <PageLoader label={LOADING_LABEL} />;
  }

  return <SafeNavigate to={migratedHref} options={{ shouldReplaceHistoryEntry: true }} />;
}
